<template>
  <v-container>
    <v-overlay
      :model-value="overlay"
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <ToolsNavigationDrawer />

    <v-stepper alt-labels :items="stepsName" hide-actions :model-value="stepId">
      <!-- step1 -->
      <template v-slot:[`item.1`]>
        <v-card flat>
          <v-card-title class="d-flex align-center">
            <span text-h6>Upload your data &nbsp;</span>
            <v-tooltip :text="tipMsg">
              <template v-slot:activator="{ props }">
                <v-icon class="mr-2" v-bind="props">mdi mdi-help-circle</v-icon>
              </template>
            </v-tooltip>
            <a href="/data-format" target="_blank">See data format</a>
          </v-card-title>
          <!-- <v-tooltip text="this is test" location="top">
            <template v-slot:activator="{ props }"> -->
          <v-file-input v-model="dataFile" clearable label="Data file" variant="solo-filled" show-size
            @change="handleDataFileChange"></v-file-input>
          <!-- </template>
          </v-tooltip> -->
          <v-file-input v-model="vocabFile" clearable label="Vocabulary file" variant="solo-filled" show-size
            @change="handleVocabFileChange"></v-file-input>
          <v-card-title class="d-flex align-center">
              <span text-h6>Try example data &nbsp;</span>
          </v-card-title>
          <v-checkbox v-model="isExample">
            <template v-slot:label>
              <div>
                Example 
              </div>
            </template>
          </v-checkbox>

          <v-divider class="mx-4 mb-1"></v-divider>
        </v-card>
      </template>

      <!-- step2 -->
      <template v-slot:[`item.2`]>
        <v-card title="Tidy Data" flat>
          <v-text-field v-model="searchCondition" label="Search" prepend-inner-icon="mdi-magnify"
          variant="outlined" hide-details single-line></v-text-field>
          <v-row style="height: 37px"></v-row>
        <v-row justify="center">
          <v-col md="6" sm="12">
            <div style="width: 100%; margin: 0 auto;">

              <v-data-table 
                v-model="selected" 
                :headers="vocaHeaders" 
                :items="vocaRowData" 
                :search="searchCondition"
                item-value="SerialNo" 
                :items-per-page="vocaItemsPerPage" 
                show-select
                :fixed-header="true"
                :height="400"
                style="border: 1px solid #212121;border-radius: 4px">
              </v-data-table>
            </div>
          </v-col>
            <v-col md="6" sm="12" >
              <div style="width: 100%; margin: 0 auto;">
              <v-data-table 
                :headers="dataColumnDefs" 
                :items="dataRowData" 
                :items-per-page="dataItemsPerPage" 
                :fixed-header="true" 
                :height="400"
                style="border: 1px solid #212121;border-radius: 4px">
              </v-data-table>
              </div>
            </v-col>
        </v-row>
      </v-card>
        <v-row style="height: 8vh"></v-row>
        <v-card title="Settings" flat variant="outlined">
          <v-card-text>
            <span style="font-weight: bolder; color: #000000 !important;">Variables Deleting Configurations</span>
          <v-row>
            <v-col cols="auto">
              <v-checkbox :model-value="true" label="With low variance" disabled></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-checkbox :model-value="true" label="With missing value" disabled></v-checkbox>
            </v-col>
          </v-row>
            <span style="font-weight: bolder; color: #000000 !important;">Transform Varialbes Type To</span>
          <v-row>
            <v-col cols="10">
              <v-radio-group v-model="optSelected" inline >
                <v-radio style="font-weight: bolder; color: #000000 !important;" label="Transform to Numeric" value="toNumeric"></v-radio>
                <v-radio style="font-weight: bolder; color: #000000 !important;" label="Transform to Factor" value="toFactor"></v-radio>
                <v-btn class="ml-4" color="info" variant="tonal" @click="transForm"> Transform </v-btn>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-dialog v-model="transFormDialog" width="auto">
            <v-card max-width="400" prepend-icon="mdi-update" :text="transFormMsg" title="Transform">
              <template v-slot:actions>
                <v-btn class="ms-auto" text="Ok" @click="transFormDialog = false"></v-btn>
              </template>
            </v-card>
          </v-dialog>
        </v-card-text>
          <!-- <v-combobox v-model="select" :items="items" label="I use " chips multiple></v-combobox> -->
        </v-card>
      </template>

      <!-- step3 -->
      <template v-slot:[`item.3`]>
        <v-row>
          <v-col cols="12">
            <v-card class="configurations-card" flat variant="outlined" title="Configurations">
              <v-row>
                <v-col md="4" sm="12">
                  <v-combobox v-model="selectOmicGruops" :items="OmicGruops" label="Omic Groups" chips
                    multiple></v-combobox>
                </v-col>
                <v-col md="4" sm="12">
                  <v-combobox v-model="selectStackingLearner" :items="stackingLearner" label="Stacking learner" chips
                    multiple></v-combobox>
                </v-col>
                <v-col md="4" sm="12">
                  <v-text-field hide-details="auto" label="Vars importance threshold" placeholder="0.85"
                    v-model="threshold"></v-text-field>
                  <div class="v-input__details">
                    <div class="v-messages"></div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4" sm="12">
                  <v-combobox v-model="selectYVariables" :items="YVariables" label="Y variables" chips
                    multiple></v-combobox>
                </v-col>
                <v-col md="4" sm="12">
                  <v-select v-model="selectedTuneMethod" label="Tune method" :items="tuneMethods"></v-select>
                </v-col>
                <v-col md="4" sm="12">
                  <v-select v-model="selectedRsmpMethod" label="Resampling method" :items="RsmpMethods"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4" sm="12">
                  <v-combobox v-model="selectCVariables" :items="CVariables" label="C variables" chips
                    multiple></v-combobox>
                </v-col>
                <v-col md="4" sm="12">
                  <v-text-field v-if="selectedTuneMethod != 'Default'" hide-details="auto" label="Tune times"
                    placeholder="10" v-model="tuneTimes"></v-text-field>
                  <div class="v-input__details">
                    <div class="v-messages"></div>
                  </div>
                </v-col>
                <v-col md="4" sm="12">
                  <v-text-field v-if="selectedRsmpMethod == 'Cross validation'" hide-details="auto" label="Folds [2-10]"
                    placeholder="5" v-model="folds"></v-text-field>
                  <v-text-field v-if="selectedRsmpMethod == 'Holdout'" hide-details="auto" label="Ratio [0.4-0.9]"
                    placeholder="0.67" v-model="ratio"></v-text-field>
                  <div class="v-input__details">
                    <div class="v-messages"></div>
                  </div>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col md="4" sm="12" class="d-flex justify-center">
                  <v-btn color="info" variant="tonal" class="run-btn">RUN</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card flat>
<!--                <template #title>-->
<!--                  <span style="font-size: 15px; font-weight: bold;">Build Model</span>-->
<!--                </template>-->
              <BuildModel />
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card title="" flat>
              <VizModel />
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- 步骤导航按钮 -->
      <div class="stepper-actionsy">
        <div class="step-content">
          <v-btn :disabled="stepId == 1" class="mr-4" size="large" variant="tonal" color="primary"
            @click="stepperPre">Prev</v-btn>
          <v-btn :disabled="stepId == 3 || loading" class="mr-4" size="large" variant="tonal" color="primary"
            @click="stepperNext">
            <!-- 显示loading状态或按钮文本 -->
            <span v-if="loading">Loading...</span>
            <span v-else>Next</span>
          </v-btn>
        </div>
      </div>
    </v-stepper>
  </v-container>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import axios from 'axios';
import BuildModel from "./BuildModel.vue";
import VizModel from "./VizModel.vue";
import ToolsNavigationDrawer from '@/components/ToolsNavigationDrawer.vue';

export default {
  name: 'StartMo',
  components: {
    BuildModel,
    VizModel,
    ToolsNavigationDrawer
  },
  data() {
    return {
      loading: false,
      overlay:false,

      gridApi: null,
      columnApi: null,

      tipMsg: "Learn more",
      transBtnPosition: "end",

      dataFileExisted: false,
      vocabFileExisted: false,
      dataFile: null,
      vocabFile: null,

      searchCondition: '',
      selected: [],
      vocaHeaders: [],
      vocaRowData: [],






      tuneTimes: 10,
      folds: 5,
      ratio: 0.67,
      threshold: 0.85,

      optSelected: 'toNumeric',
      isExample: true,

      resamplingMethod: "cv",
      selectStackingLearner: ['Lasso'],
      stackingLearner: ['Lasso', 'Elastic net', 'Random forest', 'Xgboost'],
      // stepsName: ['Upload your data', 'Tidy', 'Build Model', 'Viz Model'],
      stepsName: ['Upload your data', 'Tidy', 'Build Model'],
      stepId: 1,
      search: '',
      items: [
        'Delete variables with low variance',
        'Delete variables with missing value',
      ],
      select: ['Delete variables with low variance'],

      tuneMethods: [
        'Default',
        'Random search',
        'Grid search',
        'Non-Linear Optimization',
        'Generalized Simulated Annealing',
      ],
      selectedTuneMethod: 'Default',
      RsmpMethods: [
        'Cross validation',
        'Holdout'
      ],
      selectedRsmpMethod: 'Cross validation',

      OmicGruops: [
        // 'metabolome',
        // 'chemical',
        // 'immunome',
        // 'proteome',
      ],
      selectOmicGruops: [
        // 'metabolome',
        // 'chemical',
        // 'immunome',
      ],
      YVariables: [
        // 'Y1',
        // 'Y2',
      ],
      selectYVariables: [
        // 'Y1',
      ],
      CVariables: [
        // 'C1',
        // 'C2',
        // 'C3',
        // 'C4',
        // 'C5',
        // 'C6',
        // 'Other'
      ],
      selectCVariables: [
        // 'C1',
        // 'C2',
        // 'C3',
        // 'C4',
        // 'C5',
        // 'C6',
      ],
      tuneMethod: [
        'Default',
        'Random search',
        'Grid search',
        'Non-Linear Optimization',
        'Generalized Simulated Annealing',
      ],
      tuneMethodValue: "Default",
      themeClass: "ag-theme-quartz",
      vocaColumnDefs: [],
      dataHeaders: [],
      dataColumnDefs: [],
      dataRowData: [],
      rowSelection: {
        mode: 'multiRow',
        selectAll: 'filtered',
      },
      transFormDialog: false,
      transFormMsg: "",
      vocaItemsPerPage: 10,
      dataItemsPerPage: 10,
    }
  },
  async mounted() {
    console.log(this.dataFile)
    console.log(this.vocabFile)
    await this.doAllTable()
    this.selectAllByDefault()
  },
  watch: {
    selected: {
      handler(newValue, oldValue) {
        // 只在值真正改变时触发
        if (newValue && newValue.length > 0 && JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.onSelectionChanged(newValue);
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {

    async stepperNext() {
  // 设置loading为true，表示开始加载
  this.loading = true;
  this.overlay = true;
  console.dir("Step: " + this.stepId)

  try {
    if (this.stepId == 1) {
      let loadMomicsData = {
        "LoadMOUseExample": "True",
        "LoadMOFileDirExpo": "eg_data.xlsx",
        "LoadMOFileDirVoca": "eg_voca.xlsx"
      };
      const response = await axios.post('/exposome/LoadMomics', loadMomicsData); // eslint-disable-line no-unused-vars
      // 处理返回数据...
    } else if (this.stepId == 2) {
      const responseG = await axios.post('/exposome/variables/G', null);
      const Glist = responseG.data.split(",").slice(0, -1);
      this.OmicGruops = Glist;
      this.selectOmicGruops = Glist;

      const responseY = await axios.post('/exposome/variables/Y', null);
      const Ylist = responseY.data.split(",").slice(0, -1);
      this.YVariables = Ylist;

      const responseFirstY = await axios.post('/exposome/variables_firsty/Y', null);
      const firstYList = responseFirstY.data.split(",");
      this.selectYVariables = firstYList;

      const responseC = await axios.post('/exposome/variables/C', null);
      const Clist = responseC.data.split(",").slice(0, -1);
      this.selectCVariables = Clist;
      this.CVariables = Clist;
      this.CVariables.push("other");
    } else if (this.stepId == 3) {
      let crosData = {
        "OmicGroups": this.selectOmicGruops.join(","),
        "VarsY": this.selectYVariables.join(","),
        "VarsC": "",
        "TuneMethod": this.tuneMethodValue,
        "TuneNum": this.tuneTimes,
        "RsmpMethod": this.resamplingMethod,
        "Folds": this.folds,
        "Ratio": this.ratio,
        "Repeats": "5", //?
        "VarsImpThr": this.threshold,
        "SG_Lrns": this.selectStackingLearner
      };
      const response = await axios.post('/exposome/MulOmicsCros', crosData); // eslint-disable-line no-unused-vars
      // 处理返回数据...
    }

    // 如果请求都成功完成，步进到下一步
    this.stepId++;
    this.overlay = false;

  } catch (error) {
    console.log("请求失败", error);
    // 处理失败的情况，可以通过提示用户重新尝试
  } finally {
    // 请求完成后，无论成功还是失败，都要关闭loading状态
    this.loading = false;
  }
},
    stepperPre() {
      this.stepId--
    },
    transForm() {
      // 根据选择的列，来进行行数据转换
      var temp = this.dataRowData
      var msg = ""
      for (var j in this.dataColumnDefs) {
        var attr = this.dataColumnDefs[j].title
        var value = temp[0][attr]
        if (typeof (value) == "string") {
          msg = msg + attr + " to string "
        } else {
          msg = msg + attr + " to number "
        }
      }
      this.transFormDialog = true
      this.transFormMsg = msg
    },
    onSelectionChanged(selectedItems) {
      // 防止递归更新
      if (!selectedItems || !Array.isArray(selectedItems)) {
        return;
      }
      
      // 创建新的数组而不是直接修改
      const newColumnDefs = [];
      for (let i = 0; i < selectedItems.length; i++) {
        const item = selectedItems[i];
        newColumnDefs.push({
          title: item,
          key: item
        });
      }
      
      // 一次性更新
      this.dataColumnDefs = newColumnDefs;
    },
    async doAllTable() {
      var vocaRsp = await this.doTable("ExpoVoca.csv")
      if (!vocaRsp || !vocaRsp.header) {
        console.error('Failed to load voca data')
        return
      }
      
      var vocaHeaders = vocaRsp["header"]

      for (let i in vocaHeaders) {
        let vocaHeader = {
          align: '',
          key: '',
          sortable: false,
          title: '',
        }
        vocaHeader.key = vocaHeaders[i].title
        vocaHeader.title = vocaHeaders[i].title
        if (vocaHeader.key === 'SerialNo') {
          vocaHeader.align = 'start'
        }
        this.vocaHeaders.push(vocaHeader)
      }

      let rowAttrs = []
      for (let i in this.vocaHeaders) {
        rowAttrs.push(this.vocaHeaders[i].key)
      }
      console.log(rowAttrs)
      this.vocaRowData = vocaRsp.node
      var dataRsp = await this.doTable("ExpoData.csv")
      this.dataHeaders = dataRsp["header"]
      console.log('dataHeaders', dataRsp["header"])
      this.dataRowData = dataRsp["node"]
      console.log('dataRowData', this.dataRowData)
      this.roundToThreeDecimals()
      console.log('After dataRowData', this.dataRowData)
    },
    async doTable(filename) {
      let data = JSON.stringify({
        "path": "demo/",
        "filename": filename
      });
      try {
        const response = await axios.post('/exposome/getdemofile', data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        var rsp = this.$globalParseCsvData(response.data)
        return rsp
      } catch (error) {
        console.log(error)
      }
    },
    // fill up later
    handleDataFileChange(file) {
      if (file.length > 0) {
        console.log('File uploaded. ', file);
        this.dataFile = file
        this.dataFileExisted = true
      } else {
        console.log('No file uploaded.');
        this.dataFileExisted = false
      }
    },
    // fill up later
    handleVocabFileChange(file) {
      if (file.length > 0) {
        console.log('File uploaded. ', file);
        this.vocabFile = file
        this.vocabFileExisted = true
      } else {
        console.log('No file uploaded.');
        this.vocabFileExisted = false
      }
    },
    selectAllByDefault() {
      // 一次性赋值避免多次触发watcher
      this.selected = this.vocaRowData.map(item => item['SerialNo']);
    },
    roundToThreeDecimals() {
  this.dataRowData = this.dataRowData.map(row => {
    const updatedRow = { ...row };
    Object.keys(updatedRow).forEach(key => {
      // 检查是否为数字或可以解析为数字
      if (typeof updatedRow[key] === 'string' && !isNaN(Number(updatedRow[key]))) {
        // 解析字符串为数字
        const parsedNumber = parseFloat(updatedRow[key]);
        updatedRow[key] = parseFloat(parsedNumber.toFixed(3));
      } else if (typeof updatedRow[key] === 'number') {
        // 直接处理数字
        updatedRow[key] = parseFloat(updatedRow[key].toFixed(3));
      }
    });
    return updatedRow;
  });
},

  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

::v-deep th {
  border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;     /* 1px 宽的黑色实线右侧边框 */
}


::v-deep td {
   border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;     /* 1px 宽的黑色实线右侧边框 */
}

.step-content {
  display: flex;
  justify-content: flex-end;
  /* 使用 Flexbox 实现右对齐 */
  margin-bottom: 10px;
  /* 为底部留出距离 */
}
::v-deep(.v-combobox .v-label) {
  font-size: 18px; /* 修改为所需的字体大小 */
  color: #000000 !important; /* 可选：调整颜色 */
}
::v-deep(.v-text-field .v-label) {
  font-size: 18px; /* 修改为所需的字体大小 */
  color: #000000 !important; /* 可选：调整颜色 */
}
.run-btn {
  width: 100%;
  height: 56px;
  font-size: 16px;
  text-transform: none;
  margin-bottom: 20px;
}
.run-btn {
  width: 100%;
  height: 56px;
  font-size: 16px;
  text-transform: none;
  margin-bottom: 20px;
}
</style>